<template>
    <section class="wrap-config">
      <header class="wrap-header">
        <h3>{{this.$cookies.get('SingleTriggenData')? '编辑':'添加'}}</h3>
     </header>
     
      <main >
         <header>
          <ul>
            <span v-for="(item, index) in tabList" :key="index">
              <li
                @click="tabName = item.name;"
                :class="item.name == tabName ? 'act' : ''"
              >
              <i :class="item.icon" ></i>
                <span v-text="item.title"></span>
              </li>
            </span>
          </ul>
         </header>
         <div class="content">
          <component
            :is = "tabName"
            @closeConfig = "close"
            :processEdit="currentData"
          ></component>
        </div>
      </main>
    
    </section>
  </template>
  
  <script>
  export default {
    data() {
      return {
        // tab切换菜单项
        tabList: [
          {
            title: "时间",
            name: "addTriggerTime",
            key: 2 ,
            icon:"ant-time-icon"
          },
          {
            title: "队列",
            name: "addTriggerQueue",
            key: 3 ,
            icon:"ant-queue-icon",
          },
          {
            title: "邮件",
            name: "addTriggerEmail",
            key: 4 ,
            icon:"ant-email-icon",
          }, 
          {
            title: "文件",
            name: "addTriggerFile",
            key: 5 ,
            icon:"ant-fille-icon",
          },
        ],
        // 当前tab页名
        tabName: "addTriggerTime",

        //点击跳转标签名
        nextTab: "",

        // 当前行数据
        currentData:''

      };
    },
    components: {
        addTriggerTime: () => import("./triggerConfig/AddTriggerTime.vue"),
        addTriggerQueue: () => import("./triggerConfig/AddTriggerQueue.vue"),
        addTriggerEmail: () => import("./triggerConfig/AddTriggerMail.vue"),
        addTriggerFile: () => import("./triggerConfig/AddTriggerFile.vue"),
    },
    methods: {
      close(){
        this.$emit("close",'触发器');
      }
    },
    beforeMount(){
  
      if (this.$cookies.get('SingleTriggenData')) {
        let obj = []
        this.axios
        .post("/schedule/findById", { id: this.$cookies.get('SingleTriggenData') })
        .then((res) => {
          if (res.code === 200) {
            this.currentData = res.data
            this.tabList.forEach((item)=>{
              if(item.key === res.data.type){
                obj.push(item)
              }
            })
            this.tabList = obj
            this.tabName = this.tabList[0].name
          }
        })
        .catch((err) => {
          console.log(err);
        });
     
      
      }
    }
  };
  </script>
  
  <style lang="scss" scoped>
  .wrap-config {
    position: relative;
    background-color: #fff;
    border-radius: 4px;
    margin: -8px;
    .wrap-header {
      display: flex;
      align-items: flex-end;
      margin: -7px 2px 0;
      padding: 16px;
      letter-spacing: 1px;
      background-color: #fff;
      border-top: 1px solid #e7e8ed;
 
      h3 {
        margin-bottom: 0;
        line-height:16px;
        padding-left: 12px;
        border-left: 4px solid #3373F2;
        font-size: 18px;
        //font-weight: bold;
      }

      span {
        line-height: 16px;
        margin-left: 10px;
        color: #808080;
      }
  }

    main {
      position: relative;
      width: calc(100% - 20px);
      margin: 20px 28px 20px;

      header {
        position: absolute;
        z-index: 9;
        box-sizing: border-box;
        width: calc(100% - 30px);
        margin: 0 -5px;
        background-color: #fff;
        border-bottom: 1px #e4e8ec solid;
        padding-bottom: 0;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
      .title {
        display: flex;
        justify-content: space-between;
        // align-items: center;
      }
      ul {
        display: flex;
        height: 50px;
        line-height: 62px;
        padding-left: 20px;
  
        li {
          border-bottom: 3px solid transparent;
          padding: 0 5px;
          margin-right: 30px;
          font-size: 16px;
          cursor: pointer;
          white-space: nowrap;
  
          i.ant-time-icon {
            background: url("../assets/images/time_default.png") no-repeat center;
          }
          i.ant-queue-icon {
            background: url("../assets/images/Queue_default.png") no-repeat center;
          }
          i.ant-fille-icon {
            background: url("../assets/images/folder_default.png") no-repeat center;
          }
          i.ant-email-icon {
            background: url("../assets/images/email_default.png") no-repeat center;
          }
          i{
            cursor: pointer;
            display: inline-block;
            margin: 17px 8px 0px -5px;
            width: 25px;
            height: 25px;
            border-radius: 20px;
            vertical-align: top;
            transition: 0.3s;
          }


          &.act {
            color: #3c65f5;
            border-bottom-color: #3c65f5;
            .ant-time-icon {
              background: url("../assets/images/time_selected.png") no-repeat center;
            }
            .ant-queue-icon {
              background: url("../assets/images/queue_selected.png") no-repeat center;
            }
            .ant-fille-icon {
              background: url("../assets/images/folder_selected.png") no-repeat center;
            }
            .ant-email-icon {
              background: url("../assets/images/email_selected.png") no-repeat center;
            }
          }
        }
      }
   
    }
    .content{
      //background-color: #ffff;
      width: calc(100% - 30px);
      //max-height: calc(100vh - 210px);
      position: absolute;
      top: 65px;
      left: -5px;
      //padding: 0px 25px;
      border-bottom-left-radius: 4px;
      border-bottom-right-radius: 4px;
     }
    }
    .clear-float {
      clear: both;
    }
  }

  </style>
  